import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { IconCloseSvg } from 'apps/sigma2-ui/src/components/svg/IconClose';

export const IconAddSvg: React.FC<SvgProps> = (props) => {
  return <IconCloseSvg {...props} svg={{ className: 'rotate-45' }} />;
};
